import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "zh"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      // Earlier builds saved Chinese as "cn".
      convertDetectedLanguage: (lng: string) => (lng === "cn" ? "zh" : lng),
    },
    interpolation: {
      escapeValue: false,
    },
    backend: { loadPath: "/locales/{{lng}}/translation.json" },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
